/**
 * Checks page loading time
 * Sends error if loading takes too much time
 */

var start = Date.now();
var isFired = false;
var REPORT_THRESHOLD = 10;

var reportLoadingTime = (isUnload = false) => {
  if (isFired || !('Raven' in window)) { return }
  isFired = true;

  var diff = Date.now() - start;
  var secondsPassed = Math.floor(diff / 1000);

  if (secondsPassed < REPORT_THRESHOLD) { return }

  var message = `Loading document took more than ${REPORT_THRESHOLD} seconds.`;
  Raven.captureMessage(message, {
    level: 'info',
    logger: 'performance',
    extra: {
      seconds_passed: secondsPassed,
      left_the_page: isUnload
    }
  });
}

window.queue.afterAppLoaded(function () {
  if ('$' in window) {
    $(reportLoadingTime.bind(null, false));
  } else {
    document.addEventListener('DOMContentLoaded', reportLoadingTime.bind(null, false));
  }
});

window.onunload = reportLoadingTime.bind(null, true);
